// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".border-bottom[data-v-99494460]{border-color:#e8e8e8!important}.theme--light.v-card[data-v-99494460]{background-color:#fff}.email-mobile-tabs[data-v-99494460],.theme--light.v-tabs>.v-tabs-bar[data-v-99494460]{background-color:#f4f4f4}[data-v-99494460] .v-slide-group__content.v-tabs-bar__content{background-color:#f4f4f4;border-radius:8px;padding:3px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
